// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__Uc0b3","table":"Table_table__fSlde"};